function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Icons/remove-input.svg");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-People",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "MyProfile_Public_Edit01-Copy",
  transform: "translate(-1140.000000, -625.000000)",
  fill: "#B8C1C4"
}, React.createElement("g", {
  id: "Icons/remove-input.svg",
  transform: "translate(1140.000000, 625.000000)"
}, React.createElement("g", {
  id: "remove-input"
}, React.createElement("path", {
  d: "M7,13.5 C10.5898509,13.5 13.5,10.5898509 13.5,7 C13.5,3.41014913 10.5898509,0.5 7,0.5 C3.41014913,0.5 0.5,3.41014913 0.5,7 C0.5,10.5898509 3.41014913,13.5 7,13.5 Z M7,12.5 C3.96243388,12.5 1.5,10.0375661 1.5,7 C1.5,3.96243388 3.96243388,1.5 7,1.5 C10.0375661,1.5 12.5,3.96243388 12.5,7 C12.5,10.0375661 10.0375661,12.5 7,12.5 Z",
  id: "Oval"
}), React.createElement("path", {
  d: "M5.42047413,4.64297667 L6.99108147,6.21425821 L8.5631714,4.64297714 C8.78012934,4.4260192 9.13188767,4.4260192 9.34884561,4.64297714 C9.56580354,4.85993508 9.56580354,5.2116934 9.34884561,5.42865134 L7.77708147,6.99925821 L9.34884513,8.57134767 C9.56580307,8.78830561 9.56580307,9.14006393 9.34884513,9.35702187 C9.1318872,9.57397981 8.78012887,9.57397981 8.56317093,9.35702187 L6.99108147,7.78525821 L5.4204746,9.35702235 C5.20351666,9.57398029 4.85175833,9.57398029 4.63480039,9.35702235 C4.41784246,9.14006441 4.41784246,8.78830609 4.63480039,8.57134815 L6.20608147,6.99925821 L4.63479992,5.42865087 C4.41784199,5.21169293 4.41784199,4.8599346 4.63479992,4.64297666 C4.85175786,4.42601872 5.20351619,4.42601873 5.42047413,4.64297667 Z",
  id: "Combined-Shape"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/remove-input.17a835c1.svg";
export { SvgComponent as ReactComponent };